import { useNavigate, useLocation } from 'react-router-dom';
import { BiHomeAlt } from 'react-icons/bi';
import { LuChartLine } from 'react-icons/lu';
import Button from '../../kit/button/Button';
import { AppRoutes } from 'src/types/app-routes.enum';
import styles from './Footer.module.css';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const handleHomeButtonClick = () => navigate(AppRoutes.Home);
  const handleDataButtonClick = () => navigate(AppRoutes.Data);
  const isActive = (path: AppRoutes) => location.pathname === path;

  return (
    <div className={styles.footer}>
      <Button
        width='full-width'
        type='transparent'
        onClick={handleHomeButtonClick}
        style={{
          fontWeight: 500,
          opacity: isActive(AppRoutes.Home) ? 1 : 0.6,
          width: '100%',
          marginLeft: 0,
        }}
      >
        <BiHomeAlt size={20} />
        &nbsp;Home
      </Button>
      <Button
        width='full-width'
        type='transparent'
        onClick={handleDataButtonClick}
        style={{
          fontWeight: 500,
          opacity: isActive(AppRoutes.Data) ? 1 : 0.6,
          width: '100%',
          marginLeft: 0,
        }}
      >
        <LuChartLine size={20} />
        &nbsp;Data
      </Button>
    </div>
  );
};

export default Footer;
